// src/App.js
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import FeatureAndServiceTabs from './components/FeatureAndServiceTabs'; // NEW component
import Footer from './components/Footer';
import Main from './components/Main'; // Now only contains Hero
import Navbar from './components/Navbar';

function App() {
  return (
    <>
      <Navbar />
      {/* All sections should have padding-top to account for the fixed Navbar */}
      <Main /> {/* Hero section only */}
      <FeatureAndServiceTabs /> {/* Tabbed "Why Choose Us?" and "Our Services" */}
      <AboutUs />
      <Contact />
      <Footer />
    </>
  );
}

export default App;